// WordPress dependencies
import { ExternalLink, Disabled } from "@wordpress/components";
import { __ } from "@wordpress/i18n";

export default function (props) {
    if (!props.proFeatureEnabled && props.proFeatures && props.proFeatures.includes(props.value)) {
        return (
            <a
                href="https://codecanel.com/wp-before-after-image-slider/#product-pricing"
                target="_blank"
                className={"coca-disable-feature"}
                style={{ ...props.style, textDecoration: "none" }}
            >
                <Disabled>{props.children}</Disabled>
                <div className={"buy-pro-overlay"}>
                    {/* <ExternalLink href={props.buyPro} className="components-button is-primary">
                        {__("BUY PRO", "wp-before-after-image-slider")}
                    </ExternalLink> */}
                </div>
            </a>
        );
    }

    return props.children;
}
